<mat-card>
  <h2 translate>formationTips.title</h2>
  <mat-card-content>
    <p translate>formationTips.subtitle</p>
  </mat-card-content>
</mat-card>

<mat-tab-group color="accent">
  <mat-tab label="{{ 'tips.tab.technology' | translate }}">
    <mat-card>
      <h2 translate>technology.title</h2>
      <mat-card-content class="technology__content">
        <p class="technology__content-paragraph" [innerHTML]="'technology.content' | translate"></p>
      </mat-card-content>
    </mat-card>
  </mat-tab>
  <mat-tab label="{{ 'tips.tab.tip' | translate }}">
    <mat-card>
      <h2 class="tips__content-title" translate>tips.title</h2>
      <mat-card-content class="tips__content">
        <p translate>tips.subtitle</p>

        <div class="tips__content-table">
          <table aria-label="tips">
            <th></th>
            <th translate>tipsRequirements.min</th>
            <th translate>tipsRequirements.max</th>
            <tr class="tips__content-table-row" *ngFor="let element of requirements">
              <td class="information__table-content--bold">
                {{ element.name }}
              </td>
              <td class="information__table-content--normal">
                {{ element.min }}
              </td>
              <td class="information__table-content--normal">
                {{ element.max }}
              </td>
            </tr>
          </table>
        </div>

        <mat-label class="tips__content-subtitle" translate>tips.recomendations</mat-label>
        <p translate>tips.recomendationsText</p>

        <div class="tips__content-button">
          <button mat-stroked-button color="accent" (click)="onClickTestSpeed()">
            <mat-label translate>tips.buttonSpeedTest</mat-label>
            <mat-icon class="icon-ic_launch"></mat-icon>
          </button>
        </div>
        <mat-label translate>tips.labelMoreInfo</mat-label>
      </mat-card-content>
    </mat-card>
  </mat-tab>
</mat-tab-group>
